import { render, staticRenderFns } from "./ResultComplex.vue?vue&type=template&id=65b11334"
import script from "./ResultComplex.vue?vue&type=script&lang=js"
export * from "./ResultComplex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports